export const invoiceGroupsEn = {
  //BEGIN Michael
  INVOICE_GROUP: 'Invoice Group',
  INVOICE_GROUPS: 'Invoice Groups',
  FUND_CONFIRMATION: 'Are you sure you want to fund the selected batches?',
  FUND_CONFIRMATION_WITH_ACCOUNT:
    'This will fund all {total} batches for account {account}, including any not currently visible on this page. Are you sure?',
  FUND_CONFIRMATION_NO_ACCOUNT:
    'This will fund all {total} batches with no account set, including any not currently visible on this page. Are you sure?',
  ORIGIN_ACCOUNT_TOOLTIP:
    'Optional. Only sets the GL code on the AP Bank Account ledger entry — the bank account the funds are actually transferred from is still controlled by the payment method / funding instruction settings.',
  ORIGIN_ACCOUNT: 'Origin Account',
  ORIGIN_ACCOUNT_DISBURSEMENT_TOOLTIP:
    'For now, this only affects the custom GL code — it does not affect the NACHA file or which bank account the funds are actually transferred from.',
  FUND_SUCCESSFULLY: 'Invoices Funded Successfully!',
  SELECT_ALL: 'Select All',
  SELECT_ALL_WITH_ACCOUNT: 'Select all with {account} ({count})',
  SELECT_ALL_NO_ACCOUNT: 'Select all with no account set ({count})',
  SELECT_ALL_ACCOUNT_BANNER: 'Only {paymentType} batches for account {account} were selected — {visible} visible, {total} in total.',
  SELECT_ALL_ACCOUNT_BANNER_NO_ACCOUNT:
    'Only {paymentType} batches with no account set were selected — {visible} visible, {total} in total.',
  ACCOUNT_SCOPE_CHECKBOX_DISABLED_TOOLTIP:
    'Selection is scoped to this account across all pages — clear it first to select individual batches.',
  MOVE_TO_TITLE_DIALOG_TEXT: 'Move {type} to {status}',
  MOVE_TO_DIALOG_FIRST_BODY_TEXT: 'Move {invoices} to {status} status?',
  MOVE_TO_ACTION_BUTTON_LABEL: 'Move to {status}',
  MOVE_TO_DIALOG_SECOND_BODY_TEXT: 'You may continue modifying this invoice group until it is funded.',
  MOVE_TO_SUCCESSFULLY: '{type} {invoices} moved to {status} successfully!',
  CONFIRM_STATUS_CHANGE: 'Confirm Status Change',
  FUNDING_BATCH_ID: 'Funding Batch ID',
  NACHA_INDIVIDUAL_ID: 'Individual ID Number',
  NACHA_INDIVIDUAL_ID_TOOLTIP: 'NACHA v3 correlative reference for this transaction. Only set for factors using NACHA v3 (Wells Fargo).',
  TOTAL_PAYMENT_FEES: 'Total Payment Fees',
  TOTAL_INVOICES_AMOUNT: 'Total Invoices Amount',
  TOTAL_RESERVE_ESCROW: 'Total Reserve Escrow',
  RESERVE_ESCROW: 'Reserve Escrow',
  HELD_RESERVE: 'Held Reserve',
  TOTAL_PURCHASE_FEES: 'Total Purchase Fees',
  RESERVE_HELD_RELEASED: 'Reserve Held/Released',
  //END Michael

  //BEGIN Fco
  DOWNLOAD_REMITTANCE_CSV: 'Download Remittance CSV',
  DOWNLOAD_REMITTANCE_PDF: 'Download Remittance PDF',
  BODY_DOWNLOAD_REMITTANCE_CSV: 'Are you sure you want to download the Remittance CSV file?',
  BODY_DOWNLOAD_REMITTANCE_PDF: 'Are you sure you want to download the Remittance PDF file?',
  //END Fco

  //BEGIN Fabian
  FUND: {
    SINGLE: 'Fund',
    PLURAL: 'Funds',
  },

  FUNDED: {
    SINGLE: 'Funded',
    PLURAL: 'Funded',
  },

  NOT_FUNDED: {
    SINGLE: 'Not Funded',
    PLURAL: 'Not Funded',
  },

  FUND_SELECTED: 'Fund Selected',
  INVOICE_PURCHASED: 'Invoices Purchased',
  RESERVE: 'Reserve',
  PAYMENT_AMOUNT: 'Payment Amount',
  PAYMENT_BATCH: 'Payment Batch',
  BATCH_ID: 'Batch ID',
  TITLE_TYPE_PAYMENT_APPROVE_FOR_FUNDING: '{type_payment}: Approved For Funding ',
  DOWNLOAD_MESSAGE: 'Do you want to download the CSV?',
  RETRY_TANK_CONFIRMATION: 'Are you sure you want to retry the selected batch?',
  RETRY_TANK_SUCCESSFULLY: 'Batch Retried Successfully!',
  FUNDED_METHOD: 'Funded Method',
  FUNDED_STATUS: 'Funded Status',
  TOTAL_PAYMENT_AMOUNT: 'Total Payment Amount',
  //END Fabian

  //BEGIN Esteban
  UPDATE_INVOICE_GROUP_SUCCEED: 'Invoice Group Updated Successfully',
  //End Esteban

  //BEGIN Patricio
  DOWNLOAD_FUNDING_CSV: 'Download Funding CSV',
  BODY_DOWNLOAD_FUNDING_CSV: 'Are you sure you want to download the Funding CSV file?',
  //END Patricio
}

export const invoiceGroupsEs: typeof invoiceGroupsEn = {
  //BEGIN Michael
  INVOICE_GROUP: 'Grupo de Facturas',
  INVOICE_GROUPS: 'Grupos de Facturas',
  FUND_CONFIRMATION: '¿Está seguro de que desea comprar los grupos seleccionados?',
  FUND_CONFIRMATION_WITH_ACCOUNT:
    'Esto va a financiar los {total} lotes en total de la cuenta {account}, incluyendo los que no se ven en esta página. ¿Está seguro?',
  FUND_CONFIRMATION_NO_ACCOUNT:
    'Esto va a financiar los {total} lotes en total que no tienen cuenta asignada, incluyendo los que no se ven en esta página. ¿Está seguro?',
  ORIGIN_ACCOUNT_TOOLTIP:
    'Opcional. Solo define el código GL del asiento en el ledger de AP Bank Account — la cuenta bancaria desde la que realmente se transfieren los fondos sigue siendo controlada por el método de pago / funding instruction.',
  ORIGIN_ACCOUNT: 'Cuenta de Origen',
  ORIGIN_ACCOUNT_DISBURSEMENT_TOOLTIP:
    'Por ahora, esto solo afecta al GL code personalizado — no afecta el archivo NACHA ni la cuenta bancaria desde la que realmente se transfieren los fondos.',
  FUND_SUCCESSFULLY: '¡Grupos de facturas comprados con éxito!',
  SELECT_ALL: 'Seleccionar Todos',
  SELECT_ALL_WITH_ACCOUNT: 'Seleccionar todos con {account} ({count})',
  SELECT_ALL_NO_ACCOUNT: 'Seleccionar todos sin cuenta asignada ({count})',
  SELECT_ALL_ACCOUNT_BANNER: 'Solo se seleccionaron lotes de {paymentType} para la cuenta {account} — {visible} visibles, {total} en total.',
  SELECT_ALL_ACCOUNT_BANNER_NO_ACCOUNT:
    'Solo se seleccionaron lotes de {paymentType} sin cuenta asignada — {visible} visibles, {total} en total.',
  ACCOUNT_SCOPE_CHECKBOX_DISABLED_TOOLTIP:
    'La selección está limitada a esta cuenta en todas las páginas — límpiela primero para seleccionar lotes individuales.',
  MOVE_TO_TITLE_DIALOG_TEXT: 'Mover facturas a {status}',
  MOVE_TO_DIALOG_FIRST_BODY_TEXT: '¿Mover {invoices} a {status}?',
  MOVE_TO_ACTION_BUTTON_LABEL: 'Mover a {status}',
  MOVE_TO_DIALOG_SECOND_BODY_TEXT: 'Puede continuar modificando este grupo de facturas hasta que se compre.',
  MOVE_TO_SUCCESSFULLY: '¡Factura {invoices} movida a {status} con éxito!',
  CONFIRM_STATUS_CHANGE: 'Confirmar cambio de estado',
  FUNDING_BATCH_ID: 'ID de lote de compra',
  NACHA_INDIVIDUAL_ID: 'Número de Individual ID',
  NACHA_INDIVIDUAL_ID_TOOLTIP: 'Correlativo de referencia NACHA v3 para esta transacción. Solo aplica a factors que usan NACHA v3 (Wells Fargo).',
  TOTAL_PAYMENT_FEES: 'Total de tarifas de pago',
  TOTAL_INVOICES_AMOUNT: 'Monto total de las facturas',
  TOTAL_RESERVE_ESCROW: 'Total de reserva de garantía',
  RESERVE_ESCROW: 'Reserva de garantía',
  HELD_RESERVE: 'Reserva retenida',
  TOTAL_PURCHASE_FEES: 'Total de tarifas de compra',
  RESERVE_HELD_RELEASED: 'Reserva retenida/liberada',
  //END Michael

  //BEGIN Fco
  DOWNLOAD_REMITTANCE_CSV: 'Descargar CSV de Remesa',
  DOWNLOAD_REMITTANCE_PDF: 'Descargar PDF de Remesa',
  BODY_DOWNLOAD_REMITTANCE_CSV: '¿Está seguro de que desea descargar el archivo CSV de Remesa?',
  BODY_DOWNLOAD_REMITTANCE_PDF: '¿Está seguro de que desea descargar el archivo PDF de Remesa?',
  //END Fco

  //BEGIN Fabian
  FUND: {
    SINGLE: 'Fondo',
    PLURAL: 'Fondos',
  },

  FUNDED: {
    SINGLE: 'Comprado',
    PLURAL: 'Comprados',
  },

  NOT_FUNDED: {
    SINGLE: 'No Comprado',
    PLURAL: 'No Comprados',
  },
  FUND_SELECTED: 'Seleccionar fondos',
  INVOICE_PURCHASED: 'Facturas compradas',
  RESERVE: 'Reserva',
  PAYMENT_AMOUNT: 'Monto de pago',
  PAYMENT_BATCH: 'Lote de pago',
  BATCH_ID: 'ID de lote',
  TITLE_TYPE_PAYMENT_APPROVE_FOR_FUNDING: 'Grupos de facturas: {type_payment}',
  DOWNLOAD_MESSAGE: '¿Desea descargar el CSV?',
  RETRY_TANK_CONFIRMATION: '¿Está seguro de que desea reintentar el lote seleccionado?',
  RETRY_TANK_SUCCESSFULLY: '¡Lote reintentado con éxito!',
  FUNDED_METHOD: 'Método de compra',
  FUNDED_STATUS: 'Estado de compra',
  TOTAL_PAYMENT_AMOUNT: 'Monto total de pago',
  //END Fabian

  //BEGIN Esteban
  UPDATE_INVOICE_GROUP_SUCCEED: 'Grupo de Facturas Actualizado Correctamente',
  //End Esteban

  //BEGIN Patricio
  DOWNLOAD_FUNDING_CSV: 'Descargar CSV de Compra',
  BODY_DOWNLOAD_FUNDING_CSV: '¿Está seguro de que desea descargar el archivo CSV de Compra?',
  //END Patricio
}
